import { Card, CardColor, CardNameIndex } from "./q2_card_common";
import PokerTableAssemblyPokerBase from "../../../table/module/poker_table/poker_table_ assembly_poker_base";

const { ccclass, property, menu } = cc._decorator;

const const_color_config = {
    [1]: 'color_black_heart',
    [2]: 'color_red_heart',
    [3]: 'color_plum',
    [4]: 'color_square',
}

@ccclass
export default class Q2TablePoker extends PokerTableAssemblyPokerBase{

    @property([cc.Node])
    nodePosTagList: cc.Node[] = []

    protected static s_firstCardCode: number = -1
    static setFirstCardCode(code: number){
        Q2TablePoker.s_firstCardCode = code
    }

    protected calcColorPoint(code: number): { point: number; color: number; } {
        return {point: Card.codeToIndex(code), color: Card.codeToColor(code)}
    }
    protected isRedColor(color: number): boolean {
        return color == CardColor.color_red_heart || color == CardColor.color_square
    }
    
    protected getBigColorSpriteFrame(color: number, point: number){
        let key = `${const_color_config[color]}_big`
        return this.getSpriteFrameByName(key)
    }

    setFace(code: number){
        super.setFace(code)
        let posIndex = Card.fullCodeToAreaIndex(code)
        this.showPosTag(true, posIndex - 1)
        this.showQ2Tag(Card.isQ2(code) && posIndex <= 0)
        let logicCode = Card.codeToLogicCode(code)
        this.showFirstCardTag(logicCode == Q2TablePoker.s_firstCardCode)
    }

    showPosTag(show: boolean, localPos?: number){
        for (let index = 0; index < this.nodePosTagList.length; index++) {
            const node = this.nodePosTagList[index];
            node.active = !!show && localPos == index
        }
    }

    showQ2Tag(show: boolean){
        this.showDouble(show)
    }

    showFirstCardTag(show: boolean){
        this.showLaiZiTag(show)
    }

    
}
